<template>
  <vs-input ref="mlInput" className="ml-input"
            v-model="inputValue"
            :type="type"
            :readonly="readonly" :disabled="disabled"
            :icon-pack="iconPack" :icon="icon"
            :placeholder="placeholder"
            :max="parseInt(maxValue)" :min="minValue"
            @keyup="(e) => $emit('keyup', e)"
            @click="(e) => $emit('click', e)"
            @focusout="onFocusout"
  />
</template>

<script>
export default {
  name: "MaxLengthInput",
  props: {
    type: {type: String, default: "text"},
    value: {type: String | Number, default: ""},
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    max: {type: Number | String, default: 200},
    iconPack: String,
    icon: String,
    noneCount: String,
    minValue: Number,
    maxValue: Number | String,
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
    inputValue: {
      immediate: true,
      deep: true,
      handler(value) {
        // value에서 noneCount 문자를 모두 제거
        if (this.noneCount) value = value.replaceAll(this.noneCount, "");

        if (value && value.length > parseInt(this.max)) {
          this.inputValue = this.value;
          alert(`${this.max}자까지 작성할 수 있습니다.`);
          // this.$refs.mlInput.focus();
        } else {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      },
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  methods: {
    checkNumberMinMax() {
      if (this.minValue && this.inputValue < this.minValue) {
        this.inputValue = this.minValue;
      } else if (this.maxValue && this.inputValue > this.maxValue) {
        this.inputValue = this.maxValue;
      }
    },
    onFocusout(e) {
      if (this.type === 'number') {
        this.checkNumberMinMax();
      }
      this.$emit("focusout", e);
    },
  }
};
</script>

<style lang="scss" scoped>
.ml-input::v-deep {
  .input-span-placeholder {
    line-height: 1.2rem;
  }
}
</style>
